const { configJson, prettySeasonTennisUrl } = require('../rcs_gaz_mc_core_FE');

class ConfigManager {
  static getEnv() {
    configJson.urlToUse = process.env.REACT_APP_ENV;
    return process.env.REACT_APP_ENV;
  }

  static getContextRoot() {
    return configJson.endpoints[this.getEnv()];
  }

  static getServiceInfo(group, serviceName) {
    const serviceObject = configJson.serviceCollection[group][serviceName];
    return serviceObject;
  }

  static getApiVersion() {
    return configJson.apiVersion;
  }

  static getConstants() {
    return configJson.constants;
  }

  static getBettingEndpoint() {
    return configJson.endpoints.bet;
  }

  static buildUrl(contextRoot, apiName, urlParameters) {
    urlParameters.version = this.getApiVersion();
    return `${contextRoot}${apiName(urlParameters)}`;
  }

  static getSportRefreshInterval(sportId) {
    return configJson.sportRefreshInterval[sportId];
  }
  static getLanguageDictionary() {
    return configJson.dictionary[configJson.language];
  }
  static getRoute(routeName) {
    if ((routeName === 'cupcalendar' && this.getEnv() === 'production' && (window.matchcenterPage.sportId === '1' && window.matchcenterPage.competitionId === 105 && window.matchcenterPage.playoff === true))
      || (routeName === 'cupcalendar' && this.getEnv() === 'stag' && (window.matchcenterPage.sportId === '1' && window.matchcenterPage.competitionId === 105 && window.matchcenterPage.playoff === true))) {
      const routeObject = configJson.routes[routeName];
      let matchCenterLocation = routeObject[this.getEnv()]();
      if (matchCenterLocation.substring(matchCenterLocation.length - 1) !== '/') {
        matchCenterLocation += '/';
      }
      return matchCenterLocation;
    } else if ((routeName === 'cyclecalendar' && this.getEnv() === 'production' && (window.matchcenterPage.sportId === '18'))
      || (routeName === 'cyclecalendar' && this.getEnv() === 'stag' && (window.matchcenterPage.sportId === '18'))) {
      const routeObject = configJson.routes[routeName];
      let matchCenterLocation = routeObject[this.getEnv()]();
      if (matchCenterLocation.substring(matchCenterLocation.length - 1) !== '/') {
        matchCenterLocation += '/';
      }
      return matchCenterLocation;
    } else if ((routeName === 'tenniscalendar' && this.getEnv() === 'production' && (window.matchcenterPage.sportId === '8'))
      || (routeName === 'tenniscalendar' && this.getEnv() === 'stag' && (window.matchcenterPage.sportId === '8'))) {
      const routeObject = configJson.routes[routeName];
      let matchCenterLocation = routeObject[this.getEnv()]();
      if (matchCenterLocation.substring(matchCenterLocation.length - 1) !== '/') {
        matchCenterLocation += '/';
      }
      return matchCenterLocation;
    } else if ((routeName === 'motorsportcalendar' && this.getEnv() === 'production' && (window.matchcenterPage.sportId === '6M' || window.matchcenterPage.sportId === '6C'))
      || (routeName === 'motorsportcalendar' && this.getEnv() === 'stag' && (window.matchcenterPage.sportId === '6M' || window.matchcenterPage.sportId === '6C'))) {
      const routeObject = configJson.routes[routeName];
      let matchCenterLocation = routeObject[this.getEnv()]();
      if (matchCenterLocation.substring(matchCenterLocation.length - 1) !== '/') {
        matchCenterLocation += '/';
      }
      return matchCenterLocation;
    } else if ((routeName === 'calendar' && this.getEnv() === 'production' && (window.matchcenterPage.competitionId !== 4 || window.matchcenterPage.competitionId !== 5 || window.matchcenterPage.competitionId !== 6))
      || (routeName === 'calendar' && this.getEnv() === 'stag' && (window.matchcenterPage.competitionId !== 4 || window.matchcenterPage.competitionId !== 5 || window.matchcenterPage.competitionId !== 6))) {
      const routeObject = configJson.routes[routeName];
      let matchCenterLocation = routeObject[this.getEnv()]();
      if (matchCenterLocation.substring(matchCenterLocation.length - 1) !== '/') {
        matchCenterLocation += '/';
      }
      return matchCenterLocation;
    } else if ((routeName === 'cupcalendar' && this.getEnv() === 'production') || (routeName === 'cupcalendar' && this.getEnv() === 'stag')) {
      const routeObject = configJson.routes[routeName];
      let matchCenterLocation = routeObject[this.getEnv()]();
      if (matchCenterLocation.substring(matchCenterLocation.length - 1) !== '/') {
        matchCenterLocation += '/';
      }
      return matchCenterLocation;
    } else if ((routeName === 'volleycalendar' && this.getEnv() === 'production' && (window.matchcenterPage.sportId === '5'))
      || (routeName === 'volleycalendar' && this.getEnv() === 'stag' && (window.matchcenterPage.sportId === '5'))) {
      const routeObject = configJson.routes[routeName];
      let matchCenterLocation = routeObject[this.getEnv()]();
      if (matchCenterLocation.substring(matchCenterLocation.length - 1) !== '/') {
        matchCenterLocation += '/';
      }
      return matchCenterLocation;
    } else if ((routeName === 'volleycalendarchampionship' && this.getEnv() === 'production' && (window.matchcenterPage.sportId === '5'))
      || (routeName === 'volleycalendarchampionship' && this.getEnv() === 'stag' && (window.matchcenterPage.sportId === '5'))) {
      const routeObject = configJson.routes[routeName];
      let matchCenterLocation = routeObject[this.getEnv()]();
      if (matchCenterLocation.substring(matchCenterLocation.length - 1) !== '/') {
        matchCenterLocation += '/';
      }
      return matchCenterLocation;
    } else if ((routeName === 'basketcalendarchampionship' && this.getEnv() === 'production' && (window.matchcenterPage.sportId === '3'))
      || (routeName === 'basketcalendarchampionship' && this.getEnv() === 'stag' && (window.matchcenterPage.sportId === '3'))) {
      const routeObject = configJson.routes[routeName];
      let matchCenterLocation = routeObject[this.getEnv()]();
      if (matchCenterLocation.substring(matchCenterLocation.length - 1) !== '/') {
        matchCenterLocation += '/';
      }
      return matchCenterLocation;
    } else if ((routeName === 'nbacalendar' && this.getEnv() === 'production' && (window.matchcenterPage.sportId === '3'))
        || (routeName === 'nbacalendar' && this.getEnv() === 'stag' && (window.matchcenterPage.sportId === '3'))) {
      const routeObject = configJson.routes[routeName];
      let matchCenterLocation = routeObject[this.getEnv()]();
      if (matchCenterLocation.substring(matchCenterLocation.length - 1) !== '/') {
        matchCenterLocation += '/';
      }
      return matchCenterLocation;
    } else if ((routeName === 'rugbycalendar' && this.getEnv() === 'production' && (window.matchcenterPage.sportId === '2'))
        || (routeName === 'rugbycalendar' && this.getEnv() === 'stag' && (window.matchcenterPage.sportId === '2'))) {
      const routeObject = configJson.routes[routeName];
      let matchCenterLocation = routeObject[this.getEnv()]();
      if (matchCenterLocation.substring(matchCenterLocation.length - 1) !== '/') {
        matchCenterLocation += '/';
      }
      return matchCenterLocation;
    } else {
      const routeObject = configJson.routes[routeName];
      return routeObject[this.getEnv()]();
    }
  }

  static getFootballTeams(res) {
    return configJson.imageUrls.football.teams[res];
  }

  static getCountriesFlag() {
    return configJson.imageUrls.countriesFlag;
  }

  static getVolleyTeams(size) {
    return configJson.imageUrls.volley.teams[size];
  }

  static getMotorCircuit() {
    return configJson.imageUrls.circuits;
  }

  static getBasketTeams(res) {
    return configJson.imageUrls.basket.teams[res];
  }

  static getRugbyTeams(res) {
    return configJson.imageUrls.rugby.teams[res];
  }

  static prettySeasonTennisUrl(sportId, competitionName, isStanding, site) {
    return prettySeasonTennisUrl(sportId, competitionName, isStanding, site);
  }
}

export default ConfigManager;



// WEBPACK FOOTER //
// ./src/common/configManager/configManager.js